import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'resolvedProspects',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Resolved Prospects',
  },
}

const keys = {
  statKey: 'resolved',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const resolvedProspects = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { resolvedProspects }
